import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddWithholdingRequest } from '../models/request/withholding/AddWithholdingRequest';
import { GetWithholdingListPagingAndFilterRequest } from '../models/request/withholding/GetWithholdingListPagingAndFilterRequest';
// import { GetWithholdingListPagingAndFilterRequest } from '../models/request/withholding/GetWithholdingListPagingAndFilterRequest';

export class WithholdingService {
    static async getWithholdingList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getWithholdingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/getWithholdingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportWithholdingList(inputObj: GetWithholdingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportWithholdingList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/exportWithholdingList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWithholdingListPagingAndFilter(inputObj: GetWithholdingListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetWithholdingListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/GetWithholdingListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addWithholding(inputObj: AddWithholdingRequest) {
        try {
            console.log('SERVICE CALL - AddWithholding', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/AddWithholding', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteWithholding(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteWithholding', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/deleteWithholding', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWithholdingById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getWithholdingById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/getWithholdingById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWithholdingByWithholdingRateIdAndDate(_withholdingRateId: string, _date: string) {
        try {
            var inputObj = {
                withholdingRateId: _withholdingRateId,
                date: _date
            };

            console.log('SERVICE CALL - getWithholdingByWithholdingRateIdAndDate', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Withholding/getWithholdingByWithholdingRateIdAndDate', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}